<template>
    <div>
        <div>
            <PlaceHolderLoader height="12px" width="100%" :custom-class="['mb-2 rounded']" />
            <PlaceHolderLoader height="12px" width="100%" :custom-class="['mb-2 rounded']" />
            <PlaceHolderLoader height="12px" width="100%" :custom-class="['mb-2 rounded']" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HorizontalListLoader'
    }
</script>

<style lang="scss" scoped>
</style>